<div class="container-fluid">
  <div class="row no-gutters">
    <div class="col-12 cols">
      <div class="col-md-6  col-sm-12 left-section">
        <div class="logo-container">
          <ul class="d-flex" style="list-style: none;">
            <li> <img        src="../../assets/images/grammarin-logo/grammarin-logo.svg"  [routerLink]="['/']"
                alt="logo-main" class="img-fluid" class="logo"></li>              
          </ul>
        </div>
        <div class="login-form">
          <h3 style="font-size: 28px ; font-weight: 600;">Forgot Password</h3>
          <p style="line-height: 24px">No worries, we’ll send you reset instructions.</p>
          <span
            class="alert alert-danger mb-2 " id="dangerAlert" style="display: none; "></span>
          <p class="alert alert-danger mb-2 " id="dangerAlerts" [ngStyle]="{ color: color }"
            *ngIf="fieldIf === true && emailNotFound === false"> <i class="fas fa-check-circle"
              style="margin-right: 3px;"></i> {{ dangerAlerts }} </p>
          <p *ngIf="emailNotFound" class="checkmail alert success-alter" id="dangerAlerts2" style=" color: rgb(114, 28, 36); "
            [ngStyle]="{ color: color1 }"> <i class="fas fa-check-circle" style="margin-right: 3px;"></i> {{
            dangerAlerts2 }} </p>
          <form>
            <div class="form-group">
              <label for="email">Email</label>
              <input id="fp_email" type="email" class="form-control bd-light" name="fp_email" value=""
                placeholder="Enter your email" onfocus="this.placeholder=''"
                onblur="this.placeholder='Enter your email'"
                style="border-top-right-radius: 4px; border-bottom-right-radius: 4px;" required />
            </div>
            <div id="recaptcha-container"  data-size="compact" data-theme="light" style="display: flex; justify-content: center;  margin-top: 15px;"></div>
            <div class="form-group">
              <button type="submit" class="btn btn-dark  btn-block"  (click)="handleButtonClick($event)"
                style="width: 388pxpx;height: 52pxpx !important;">Reset password</button>
            </div>
          </form>
          <p class="text-center mt-4">
            <a [routerLink]="['/signin']"  class="move-up" style="cursor: pointer; color: black; text-decoration: none;"> <img
                src="../../assets/images/signin-signup/back to login.svg" alt=""> Back to Login </a>
              
          </p>
        </div>
      </div>
      <div class="col-md-6  col-sm-12 right-section">
        <div class="marginSection">
          <h4>Forgot Password</h4>
          <p>To regain access to your account, please enter your email address to reset your password.</p> <img
          src="../../assets/images/editorimages/editor-new-logo.png" alt="Illustration" class="IllustrationImage img-fluid">
        </div>
      </div>
    </div>
  </div>
</div>